export const webp = [
    {
        id: 'webp1600',
        media: '(min-width: 1600px)',
        srcset: '',
        type: 'image/webp'
    },
    {
        id: 'webp1200',
        media: '(min-width: 1200px)',
        srcset: '',
        type: 'image/webp'
    },
    {
        id: 'webp768',
        media: '(min-width: 768px)',
        srcset: '',
        type: 'image/webp'
    },
    {
        id: 'webp767',
        media: '(max-width: 767px)',
        srcset: '',
        type: 'image/webp'
    }
];

export const jpeg = [
    {
        id: 'jpeg1600',
        media: '(min-width: 1600px)',
        srcset: '',
        type: 'image/jpeg'
    },
    {
        id: 'jpeg1200',
        media: '(min-width: 1200px)',
        srcset: '',
        type: 'image/jpeg'
    },
    {
        id: 'jpeg768',
        media: '(min-width: 768px)',
        srcset: '',
        type: 'image/jpeg'
    },
    {
        id: 'jpeg767',
        media: '(max-width: 767px)',
        srcset: '',
        type: 'image/jpeg'
    }
];

export const png = [
    {
        id: 'png1600',
        media: '(min-width: 1600px)',
        srcset: '',
        type: 'image/png'
    },
    {
        id: 'png1200',
        media: '(min-width: 1200px)',
        srcset: '',
        type: 'image/png'
    },
    {
        id: 'png768',
        media: '(min-width: 768px)',
        srcset: '',
        type: 'image/png'
    },
    {
        id: 'png767',
        media: '(max-width: 767px)',
        srcset: '',
        type: 'image/png'
    }
];